import React from 'react';
import { FormProvider } from '../fluidComponents/fluidForm/FormContext';
import { DocFluidForm } from '../fluidComponents/fluidForm/DocFluidForm.component';
import { FluidForm as FluidForm } from '../../shared/FluidForm';
import { Container } from 'semantic-ui-react';
import { useRegisterFormInstance } from '../fluidComponents/fluidForm/FormInstance.service';
export const FundamentalForm = () => {
    let formConfigService = new FluidForm({
        key: "example-form",
        type: "form",
        fields: [
            { key: "Full Name", label: "Full Name", type: "fullName" },
            { key: "Email", label: "Email", type: "email" },
            { key: "Address", label: "Address", type: "address" },
            { key: "Family Members", label: "Family Members", type: "composedList",
                fields: [
                    { key: "Full Name", label: "Full Name", type: "fullName" },
                    { key: "Age", label: "Age", type: "age" },
                ]
            },
        ]
    }, {}, {
        styleConfig: {
            style: "classic",
            formInputModesPosition: "top",
            inputModes: ["email", "address"]
        }
    });
    let instanceId = useRegisterFormInstance({ form: formConfigService });
    return (React.createElement(Container, null,
        React.createElement(FormProvider, { formInstance: instanceId },
            React.createElement(DocFluidForm, { onSubmit: (d) => {
                    console.log(d);
                }, showSubmitButton: true }))));
};
